import type { EventSummary } from '../../services/eventService';

export type EventStatus = 'upcoming' | 'ongoing' | 'ended';

function todayKey() {
  const now = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

// 진행 상태는 eventDate 와 오늘만 비교한다 (기록실 여부는 isRecordRoom 으로 따로 본다)
// eventDate 는 'yyyy-mm-dd' 고정 포맷이라 문자열 비교로 충분
export function getEventStatus(event: Pick<EventSummary, 'eventDate'>): EventStatus {
  const today = todayKey();
  if (event.eventDate > today) return 'upcoming';
  if (event.eventDate === today) return 'ongoing';
  return 'ended';
}

export const EVENT_STATUS_META: Record<
  EventStatus,
  { label: string; fg: string; bg: string; solid: string }
> = {
  upcoming: { label: '진행 예정', fg: '#16a34a', bg: '#dcfce7', solid: 'rgba(22,163,74,0.92)' },
  ongoing: { label: '진행 중', fg: '#0c63a8', bg: '#e8f6fe', solid: 'rgba(13,148,196,0.92)' },
  ended: { label: '종료', fg: '#64748b', bg: '#f1f5f9', solid: 'rgba(100,116,139,0.92)' },
};

// 기록실 이동 토글(isEnd)이 켜진 대회 — 진행 상태와 별개라 두 태그가 함께 붙을 수 있다
export function isRecordRoom(event: Pick<EventSummary, 'isEnd'>): boolean {
  return !!event.isEnd;
}

export const RECORD_ROOM_META = {
  label: '기록실',
  fg: '#7c3aed',
  bg: '#f3e8ff',
  solid: 'rgba(124,58,237,0.92)',
};
